package com.example.borshi.web.cart

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.flex
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontStyle
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginLeft
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.minWidth
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.textDecoration
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.Hr
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
private fun InjectCartStyles() {
    androidx.compose.runtime.DisposableEffect(Unit) {
        if (kotlinx.browser.document.getElementById("cart-styles") != null) return@DisposableEffect onDispose {}
        val s = kotlinx.browser.document.createElement("style")
        s.id = "cart-styles"
        s.textContent = """
.cart-root{max-width:1100px;margin:0 auto;padding:24px 16px 80px;min-height:calc(100vh - 64px)}
.cart-eyebrow{font-family:'Syne',sans-serif;font-size:10px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;color:#26A69A;margin-bottom:4px}
.cart-title{font-family:'Syne',sans-serif;font-size:28px;font-weight:800;color:#0D2B2E;letter-spacing:-.04em;margin-bottom:24px}
.cart-grid{display:grid;grid-template-columns:1fr;gap:20px}
@media(min-width:768px){.cart-grid{grid-template-columns:1fr 360px;gap:28px}}
.cart-section-label{font-family:'DM Sans',sans-serif;font-size:11px;font-weight:700;letter-spacing:.10em;text-transform:uppercase;color:#7A9598;margin-bottom:12px}
.cart-item{background:white;border-radius:18px;border:1.5px solid #E0EDEB;padding:18px;margin-bottom:14px;display:flex;gap:16px;transition:box-shadow 0.2s ease}
.cart-item:hover{box-shadow:0 4px 16px rgba(13,43,46,0.08)}
.cart-item-sub{background:linear-gradient(135deg,#F0FAFA 0%,#FAFFFE 100%);border-color:#B2DFDB}
.cart-img{width:80px;height:80px;border-radius:14px;object-fit:cover;flex-shrink:0;background:#E4EFEE;display:flex;align-items:center;justify-content:center;font-size:24px;overflow:hidden}
.cart-img img{width:100%;height:100%;object-fit:cover}
.cart-info{flex:1;min-width:0}
.cart-name{font-family:'DM Sans',sans-serif;font-size:15px;font-weight:700;color:#0D2B2E;margin:0 0 3px}
.cart-meta{font-family:'DM Sans',sans-serif;font-size:12px;color:#7A9598;margin:0 0 10px}
.cart-sub-badge{display:inline-flex;align-items:center;padding:2px 8px;background:#E0F2F1;color:#1A7A72;font-size:10px;font-weight:700;letter-spacing:.06em;border-radius:999px;margin-bottom:6px;font-family:'DM Sans',sans-serif}
.cart-schedule{font-family:'DM Sans',sans-serif;font-size:12px;color:#3D5A5E;margin:0 0 8px;font-style:italic}
.cart-qty{display:flex;align-items:center;gap:8px}
.cart-qty-btn{width:30px;height:30px;border-radius:10px;background:#F5F9F8;border:1.5px solid #E0EDEB;font-size:16px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#0D2B2E;transition:all 0.15s ease;flex-shrink:0}
.cart-qty-btn:hover{background:#E0F2F1;border-color:#26A69A}
.cart-qty-num{font-family:'DM Sans',sans-serif;font-weight:700;font-size:15px;color:#0D2B2E;min-width:22px;text-align:center}
.cart-price-col{display:flex;flex-direction:column;justify-content:space-between;align-items:flex-end;flex-shrink:0}
.cart-price{font-family:'Syne',sans-serif;font-size:16px;font-weight:800;color:#D11243}
.cart-price-label{font-family:'DM Sans',sans-serif;font-size:10px;color:#7A9598;margin-bottom:2px}
.cart-remove{font-family:'DM Sans',sans-serif;font-size:11px;font-weight:600;color:#7A9598;background:none;border:none;cursor:pointer;padding:0;transition:color 0.15s ease}
.cart-remove:hover{color:#D11243}
.cart-summary{background:white;border-radius:20px;border:1.5px solid #E0EDEB;padding:24px;position:sticky;top:20px;height:fit-content;box-shadow:0 2px 16px rgba(13,43,46,0.06)}
.cart-sum-title{font-family:'Syne',sans-serif;font-size:17px;font-weight:800;color:#0D2B2E;margin-bottom:18px;letter-spacing:-.02em}
.cart-sum-row{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;font-family:'DM Sans',sans-serif;font-size:13.5px;color:#3D5A5E}
.cart-sum-row span:last-child{font-weight:600;color:#0D2B2E}
.cart-sum-row .free{color:#26A69A;font-weight:700}
.cart-sum-divider{height:1px;background:#F0F5F4;margin:14px 0}
.cart-sum-total{display:flex;justify-content:space-between;align-items:center;font-family:'Syne',sans-serif;font-size:20px;font-weight:800;color:#0D2B2E}
.cart-sum-total-price{color:#D11243}
.cart-checkout-btn{width:100%;margin-top:18px;padding:15px;font-family:'DM Sans',sans-serif;font-size:15px;font-weight:700;background:#0D2B2E;color:white;border:none;border-radius:14px;cursor:pointer;transition:all 0.18s ease;letter-spacing:0.01em}
.cart-checkout-btn:hover{background:#1A4A4E;transform:translateY(-1px);box-shadow:0 4px 16px rgba(13,43,46,0.22)}
.cart-note{font-family:'DM Sans',sans-serif;font-size:11.5px;color:#7A9598;margin-top:12px;line-height:1.5}
.cart-empty{text-align:center;padding:80px 24px;display:flex;flex-direction:column;align-items:center;gap:16px}
.cart-empty-icon{font-size:56px;line-height:1}
.cart-empty-title{font-family:'Syne',sans-serif;font-size:22px;font-weight:800;color:#0D2B2E;letter-spacing:-.03em}
.cart-empty-sub{font-family:'DM Sans',sans-serif;font-size:14px;color:#7A9598}
.cart-empty-btn{margin-top:4px;padding:13px 28px;font-family:'DM Sans',sans-serif;font-size:14px;font-weight:700;background:#0D2B2E;color:white;border:none;border-radius:12px;cursor:pointer;transition:all 0.18s ease}
.cart-empty-btn:hover{background:#26A69A;transform:translateY(-1px)}
        """.trimIndent()
        kotlinx.browser.document.head?.appendChild(s)
        onDispose {}
    }
}

@Composable
fun CartScreen(
    cartStore: CartStore,
    onContinueShopping: () -> Unit = {},
    onCheckout: () -> Unit = {}
) {
    InjectCartStyles()
    val items = cartStore.items
    val oneTimeItems = cartStore.oneTimeItems
    val subItems = cartStore.subscriptionItems

    Div({ classes("cart-root") }) {
        Div({ classes("cart-eyebrow") }) { Text("Your Selection") }
        Div({ classes("cart-title") }) { Text("Shopping Cart") }

        if (items.isEmpty()) {
            EmptyCart(onContinueShopping)
        } else {
            Div({ classes("cart-grid") }) {
                // Main Content Column
                Div {
                    if (oneTimeItems.isNotEmpty()) {
                        Div({ classes("cart-section-label") }) { Text("One-Time Delivery") }
                        oneTimeItems.forEach { item ->
                            OneTimeItemCard(
                                item = item,
                                onUpdateQty = { newQty -> cartStore.updateOneTimeQty(item.id, newQty) },
                                onRemove = { cartStore.removeItem(item.id) }
                            )
                        }
                    }

                    // Spacer
                    if (oneTimeItems.isNotEmpty() && subItems.isNotEmpty()) {
                        Div({ style { height(24.px) } })
                    }

                    if (subItems.isNotEmpty()) {
                        Div({ classes("cart-section-label") }) { Text("Subscriptions") }
                        subItems.forEach { item ->
                            SubscriptionItemCard(
                                item = item,
                                onUpdateQty = { newQty -> cartStore.updateSubscriptionQty(item.id, newQty) },
                                onRemove = { cartStore.removeItem(item.id) }
                            )
                        }
                    }
                }

                // Cart Summary Column
                CartSummaryPanel(cartStore, onCheckout)
            }
        }
    }
}

@Composable
fun EmptyCart(onContinueShopping: () -> Unit = {}) {
    Div({ classes("cart-empty") }) {
        Div({ classes("cart-empty-icon") }) { Text("🛒") }
        Div({ classes("cart-empty-title") }) { Text("Your cart is empty") }
        Div({ classes("cart-empty-sub") }) { Text("Discover fresh seafood and add items to get started") }
        Button({
            classes("cart-empty-btn")
            onClick { onContinueShopping() }
        }) { Text("Browse Products") }
    }
}

@Composable
fun OneTimeItemCard(item: CartLineItem.OneTime, onUpdateQty: (Int) -> Unit, onRemove: () -> Unit) {
    Div({ classes("cart-item") }) {
        Div({ classes("cart-img") }) {
            if (item.imageUrl != null) {
                Img(src = item.imageUrl, attrs = { style { width(100.percent); height(100.percent); property("object-fit","cover") } })
            } else { Text("🐟") }
        }
        Div({ classes("cart-info") }) {
            Div({ classes("cart-name") }) { Text(item.name) }
            Div({ classes("cart-meta") }) { Text(item.weight) }
            Div({ classes("cart-qty") }) {
                Button({ classes("cart-qty-btn"); onClick { if (item.quantity > 1) onUpdateQty(item.quantity - 1) } }) { Text("−") }
                Span({ classes("cart-qty-num") }) { Text("${item.quantity}") }
                Button({ classes("cart-qty-btn"); onClick { onUpdateQty(item.quantity + 1) } }) { Text("+") }
            }
        }
        Div({ classes("cart-price-col") }) {
            Span({ classes("cart-price") }) { Text("₹${(item.price * item.quantity).toInt()}") }
            Button({ classes("cart-remove"); onClick { onRemove() } }) { Text("Remove") }
        }
    }
}

@Composable
fun SubscriptionItemCard(item: CartLineItem.Subscription, onUpdateQty: (Int) -> Unit, onRemove: () -> Unit) {
    Div({ classes("cart-item", "cart-item-sub") }) {
        Div({ classes("cart-img") }) {
            if (item.imageUrl != null) {
                Img(src = item.imageUrl, attrs = { style { width(100.percent); height(100.percent); property("object-fit","cover") } })
            } else { Text("📅") }
        }
        Div({ classes("cart-info") }) {
            Span({ classes("cart-sub-badge") }) { Text("SUBSCRIPTION") }
            Div({ classes("cart-name") }) { Text(item.name) }
            Div({ classes("cart-schedule") }) { Text("🗓 ${item.schedule.toSummaryString()}") }
            Div({ classes("cart-meta") }) { Text("Pack: ${item.packSize}") }
            Div({ classes("cart-qty") }) {
                Span({ style { fontSize(11.px); color(Color("#7A9598")); property("font-family","DM Sans, sans-serif") } }) { Text("Qty/delivery:") }
                Button({ classes("cart-qty-btn"); onClick { if (item.quantityPerDelivery > 1) onUpdateQty(item.quantityPerDelivery - 1) } }) { Text("−") }
                Span({ classes("cart-qty-num") }) { Text("${item.quantityPerDelivery}") }
                Button({ classes("cart-qty-btn"); onClick { onUpdateQty(item.quantityPerDelivery + 1) } }) { Text("+") }
            }
        }
        Div({ classes("cart-price-col") }) {
            Div {
                Div({ classes("cart-price-label") }) { Text("per delivery") }
                Span({ classes("cart-price") }) { Text("₹${(item.price * item.quantityPerDelivery).toInt()}") }
            }
            Button({ classes("cart-remove"); onClick { onRemove() } }) { Text("Remove") }
        }
    }
}

@Composable
fun QuantityButton(label: String, onClick: () -> Unit) {
    // Legacy shim — new cards use .cart-qty-btn directly
    Button({
        classes("cart-qty-btn")
        onClick { onClick() }
    }) { Text(label) }
}

@Composable
fun CartSummaryPanel(cartStore: CartStore, onCheckout: () -> Unit) {
    val totals = cartStore.computeTotals()

    Div({ classes("cart-summary") }) {
        Div({ classes("cart-sum-title") }) { Text("Order Summary") }

        if (totals.oneTimeSubtotal > 0) SummaryRow("One-time items", totals.oneTimeSubtotal)
        if (totals.subscriptionFirstDeliverySubtotal > 0) SummaryRow("Subscription (1st delivery)", totals.subscriptionFirstDeliverySubtotal)
        SummaryRow("Delivery", totals.deliveryFee, if (totals.deliveryFee == 0.0) "FREE" else null)

        Div({ classes("cart-sum-divider") }) {}

        Div({ classes("cart-sum-total") }) {
            Span { Text("Pay Today") }
            Span({ classes("cart-sum-total-price") }) { Text("₹${totals.payTodayTotal.toInt()}") }
        }

        if (totals.subscriptionFirstDeliverySubtotal > 0) {
            Div({ classes("cart-note") }) {
                Text("Subscriptions are billed per delivery. You pay for the first delivery now.")
            }
        }

        Button({
            classes("cart-checkout-btn")
            onClick { onCheckout() }
        }) { Text("Proceed to Checkout →") }
    }
}

@Composable
fun SummaryRow(label: String, amount: Double, displayValue: String? = null) {
    Div({ classes("cart-sum-row") }) {
        Span { Text(label) }
        if (displayValue != null) {
            Span({ classes("free") }) { Text(displayValue) }
        } else {
            Span { Text("₹${amount.toInt()}") }
        }
    }
}
